import { Outlet } from "react-router-dom";

const AssetFileParentPage = () => {
    return <Outlet />
}
export default AssetFileParentPage;